import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { resolveApiUrl } from '@catch/libs';
import { init as initDash0 } from '@dash0/sdk-web';
import { browserTracingIntegration, init } from '@sentry/angular';
import { Settings } from 'luxon';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

registerLocaleData(localeDe);

init({
  dsn: 'https://fbec09a9fe125f68a7e01e80df837c72@o4509632216694784.ingest.de.sentry.io/4509723492483152',
  release: environment.version,
  environment: environment.environment,
  tracePropagationTargets: ['localhost', 'https://jobboard.catch-talents.de'],
  integrations: [browserTracingIntegration()],
  tracesSampleRate: 1.0,
});

if (environment.dash0Enabled) {
  initDash0({
    serviceName: `${environment.environment}-jobboard`,
    endpoint: {
      url: 'https://ingress.eu-west-1.aws.dash0.com',
      authToken: 'auth_UoQhgAjPju0EHqAd4VGfno2P8YUfyu5R',
      dataset: environment.production ? 'production' : 'staging',
    },
    additionalSignalAttributes: {
      environment: environment.environment,
      version: environment.version,
    },
  });
}

if (environment.production) {
  enableProdMode();

  if (window) {
    window.console.log = () => {};
  }
}

Settings.defaultZone = 'Europe/Berlin';

const initializeApp = async () => {
  environment.apiBaseUrl = await resolveApiUrl(
    environment.apiBaseUrl,
    environment.apiBaseUrlFallback,
    { enabled: !environment.production }
  );

  bootstrapApplication(AppComponent, appConfig)
    .then(() => console.log('Bootstrap success'))
    .catch((err) => console.error(err));
};

initializeApp();
